import { DSTreeBase } from './DSTreeBase';
import ListWithCatalogue from '../ListWithCatalogue';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { flattenDataSchema, searchInDataSchema } from "../../../lib/utils/dataSchema";
import { TreeState } from './TreeState';
const __script_base__ = {
  name: 'UcdSourceTree',
  components: {
    ListWithCatalogue,
    DSTreeBase
  },
  props: {
    searchKeyword: {
      type: [String, Function],
      default: ''
    },
    // 关键词或者一个过滤函数
    indentWidth: {
      type: String,
      default: '30px'
    },
    hideCatalogue: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: false
    },
    showHiddenFields: {
      type: Boolean,
      default: false
    },
    // 显示全部字段（包括隐藏的）
    sticky: {
      type: Boolean,
      default: true
    },
    showArrayItemsTree: {
      type: Boolean,
      default: false
    },
    getFieldHidden: {
      type: Function,
      default: field => field.hidden
    }
  },
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  provide() {
    return {
      dataSourceTreeContext: this
    };
  },
  created() {
    this.treeState = new TreeState();
  },
  mounted() {
    setTimeout(() => {
      const el = this.$el.querySelector('.ucd-listWithCatalogue-groupContainer');
      if (el) {
        this.treeState.init(el);
      }
    }, 3000);
  },
  computed: {
    dataStub() {
      var _this$designer$render;
      const stub = (_this$designer$render = this.designer.renderer) === null || _this$designer$render === void 0 ? void 0 : _this$designer$render.ucDataStub;
      return stub;
    },
    // 打扁的全部字段
    allFields() {
      return flattenDataSchema(this.dataStub.schema, this.dataStub.path);
    },
    dsTreeRoots() {
      const {
        dataStub,
        showHiddenFields
      } = this;
      if (!dataStub) return [];
      let roots = [{
        name: 'data',
        dataStub,
        key: 'data'
      }];
      if (dataStub.type === 'object') {
        roots = dataStub.definedFields.map(field => {
          const {
            id
          } = field;
          if (!showHiddenFields && this.getFieldHidden(field)) return null;
          const subDataStub = dataStub.getChildStub(id);
          return {
            id,
            name: subDataStub.schema.title || id,
            dataStub: subDataStub,
            path: subDataStub.path
          };
        }).filter(Boolean);
      }
      return roots;
    },
    // 给 DSTree 用的，当前搜索条件下筛选出来的 { [path]: true, ... }
    fieldFilter() {
      const key = this.searchKeyword;
      if (!key) return null;
      return searchInDataSchema(this.allFields, key);
    },
    // 经过搜索后，可能只显示部分的 dsTreeRoots，这里是筛选后的
    filteredDsTreeRoots() {
      const {
        dsTreeRoots,
        searchKeyword
      } = this;
      if (!searchKeyword) return dsTreeRoots;

      // 在搜索状态下，并不是全部 root 都命中搜索条件
      return dsTreeRoots.filter(x => this.fieldFilter[x.path]);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ListWithCatalogue", {
    staticClass: "ucd-datatree-catelist",
    attrs: {
      data: _vm.filteredDsTreeRoots,
      "category-key": "name",
      "hide-catalogue": _vm.hideCatalogue
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function () {
        return [_vm._t("empty")];
      },
      proxy: true
    }, {
      key: "title",
      fn: function (ref) {
        var group = ref.group;
        return [_c("div", {
          attrs: {
            "data-group": group
          }
        })];
      }
    }, {
      key: "item",
      fn: function (ref) {
        var ref_item = ref.item;
        var name = ref_item.name;
        var subDataStub = ref_item.dataStub;
        return [_c("DSTreeBase", {
          key: "dstree:" + name,
          attrs: {
            stub: subDataStub,
            "preferred-name": name,
            sticky: _vm.sticky
          }
        })];
      }
    }], null, true)
  });
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/DataSourceTree/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);